import React, { useEffect, useState } from 'react';
import './SplashScreen.css';
import splashBg from '../assets/svg/splash.svg';
import logoHoraeWhite from '../assets/svg/logo-horae-white.svg';

const SplashScreen = ({ onFinish }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [version, setVersion] = useState('2.0.0');

  useEffect(() => {
    // Test simple - charger la version depuis le manifest avec timestamp
    const loadVersion = async () => {
      try {
        const timestamp = Date.now();
        const response = await fetch(`/manifest.json?t=${timestamp}`);
        if (response.ok) {
          const data = await response.json();
          if (data.version) {
            setVersion(data.version);
            console.log('✅ Version chargée:', data.version);
          } else {
            console.log('⚠️ Pas de version dans manifest, utilisation par défaut');
          }
        } else {
          console.log('⚠️ Erreur manifest, utilisation par défaut');
        }
      } catch (error) {
        console.log('⚠️ Erreur réseau, utilisation par défaut:', error.message);
      }
    };

    loadVersion();

    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(onFinish, 500);
    }, 2000);

    return () => clearTimeout(timer);
  }, [onFinish]);

  return (
    <div className={`splash-screen ${isVisible ? 'visible' : 'hidden'}`}>
      <img src={splashBg} alt="Fond splash" className="splash-bg" />
      <div className="splash-content">
        <img src={logoHoraeWhite} alt="Logo Horae" className="splash-logo" />
        
        {/* Version avec style inline pour test */}
        <div style={{
          position: 'absolute',
          bottom: '30px',
          left: '50%',
          transform: 'translateX(-50%)',
          color: 'white',
          fontSize: '0.9rem',
          fontWeight: '400',
          opacity: '0.8',
          textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)',
          zIndex: 10,
          textAlign: 'center',
          whiteSpace: 'nowrap',
          backgroundColor: 'rgba(0,0,0,0.3)', // Fond pour debug
          padding: '5px 10px',
          borderRadius: '3px'
        }}>
          V.{version}
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;